import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { CRMContext } from '../../context/CRMContext';

const Navegacion = () => {
  const userId = localStorage.getItem('userId');
  const [auth] = useContext(CRMContext);

  return (
    <nav>
      <div class="navbar">
        <div className="nav-container">
          <div class="hamburger-lines">
            <span class="line line1"></span>
            <span class="line line2"></span>
            <span class="line line3"></span>
          </div>
          <nav className="menu-items">
            <Link to={'/'} className="link-menu">
              inicio
            </Link>
            <Link to={'/tutores'} className="link-menu">
              Tutores
            </Link>
            <Link to={'/cursos'} className="link-menu">
              Cursos
            </Link>

            {auth.auth ? (
              <Link
                to={`/usuarios/cambio-tutor/${userId}`}
                className="link-menu"
              >
                ¿Quieres ser tutor?
              </Link>
            ) : (
              <Link to={'/ser-tutor'} className="link-menu">
                ¿Quieres ser tutor?
              </Link>
            )}
          </nav>
        </div>
      </div>
    </nav>
  );
};

export default Navegacion;
